.root {
  font-family: var(--font-mono);
  font-weight: var(--font-weight-bold);
  line-height: 140%;
  color: var(--primary);
}
